import { createTheme } from '@material-ui/core';

declare module '@material-ui/core/styles/createTheme' {
  interface Theme {
    navHeight: number;
    backgroundColor: string;
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    navHeight: number;
    backgroundColor: string;
  }
}

export default createTheme({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        'html, body, #root': {
          height: '100%',
        },
        '@media screen and (max-width: 950px)': {
          'html, body, #root': {
            float: 'none',
            width: 'auto',
            overflow: 'scroll',
          }
        }
      },
    },
    MuiContainer: {
      root: {
        padding: '15px',
        width: '950px',
        '@media (max-width: 700px)': {
          width: 'calc( 100vw - 20px )',
          marginRight: '5px',
          padding: '0px'
        },
        '@media screen and (min-width: 701px) and (max-width: 950px)': {
          width: 'calc( 100vw - 120px )',
          marginRight: '5px',
          padding: '0px'
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: '6px',
        textTransform: 'none',
        color: 'rgb(0, 149, 255)',
        fontSize: '14px',
        fontWeight: 400,
        '@media (max-width: 950px)': {
          fontSize: '12px'
        },
      },
      text: {
        padding: '6px 14px',
      },
      contained: {
        boxShadow: 'none',
      },
      startIcon: {
        marginRight: '6px',
      },
      outlined: {
        backgroundColor: "transparent",
        border: '1px solid #E5E5E5',
      },
    },
    MuiInputBase: {
      root: {
        fontSize: '0.9rem',
      },
    },
    MuiSelect: {
      root: {
        padding: '0.85em',
      },
    },
    MuiDialogActions: {
      root: {
        padding: '16px',
      },
    },
    MuiTextField: {
      root: {
        color: 'rgb(40, 42, 43)',
      },
    },
    MuiInputLabel: {
      root: {
        color: 'rgb(40, 42, 43)',
        fontSize: '1.1rem',
        marginBottom: '0.2em',
        fontWeight: 500,
      },
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: 'rgb(136, 140, 142)',
      },
    },
    MuiTypography: {
      gutterBottom: {
        marginBottom: '36px',
        '@media screen and (max-width: 950px)': {
          marginBottom: '20px',
        }
      },
      
    },
    MuiTableCell: {
      head: {
        background: '#F4F4F6',
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '0.9rem',
      },
    },
  },
  typography: {
    fontFamily: 'IDT Sans, sans-serif',
    h1: {
      color: '#002540',
      fontSize: '40px',
      fontWeight: 700,
      '@media screen and (max-width: 950px)': {
        fontSize: '30px',
      }
    },
    h3: {
      color: '#002540',
      fontSize: '1.25rem',
      fontWeight: 700,
      lineHeight: '1.75rem',
      '@media screen and (max-width: 950px)': {
        fontSize: '1rem',
      }
    },
    body1: {
      color: '#002540',
      fontSize: '14px',
      lineHeight: '1.5rem',
      fontWeight: 400,
      '@media screen and (max-width: 400px)': {
        fontSize: '12px',
      }
    },
  },
  palette: {
    primary: {
      main: '#0096FE',
    },
    text: {
      secondary: '#606B85',
    },
  },
  navHeight: 100,
  backgroundColor: 'white',
});
